module.exports = __webpack_public_path__ + "static/img/042_9.7cb89a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/042_9.jpg
// module id = /Ehi
// module chunks = 1